import { render, staticRenderFns } from "./PageListTemplate.vue?vue&type=template&id=d3d8a6a8&"
import script from "./PageListTemplate.vue?vue&type=script&lang=js&"
export * from "./PageListTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PageListTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports